import { AdapterFactory } from './adapter-factory';

export const CheckedAdapter = AdapterFactory({ valueToInject: 'checked' });
